import axios from '../config/axiosConfig';

const API_URL = '/websocket';

const getConnections = async () => {
  const response = await axios.get(`${API_URL}/connections`);
  return response.data;
};

const getMessages = async (params = {}) => {
  const response = await axios.get(`${API_URL}/messages`, { params });
  return response.data;
};

const connect = async (data) => {
  const response = await axios.post(`${API_URL}/connect`, data);
  return response.data;
};

const send = async (data) => {
  const response = await axios.post(`${API_URL}/send`, data);
  return response.data;
};

const close = async (connectionId) => {
  const response = await axios.post(`${API_URL}/close`, { connectionId });
  return response.data;
};

const replay = async (data) => {
  const response = await axios.post(`${API_URL}/replay`, data);
  return response.data;
};

const webSocketServiceFrontend = {
  getConnections,
  getMessages,
  connect,
  send,
  close,
  replay
};

export default webSocketServiceFrontend;
